import { Button, Dialog } from "@mui/material";
import { X } from "lucide-react";
import React from "react";

const AddToSlackModal = ({ open, setOpen, channel_id }) => {
  const redirectUri = encodeURIComponent(
    "https://app.twilanswer.com/dashboard/channels"
  );
  return (
    <Dialog
      open={open}
      fullWidth={false}
      maxWidth={"sm"}
      BackdropProps={{
        style: { backgroundColor: "rgb(144,150,160,0.8)" },
      }}
    >
      <div className=" px-6 py-6 lg:w-[400px]">
        <div className="flex items-center justify-between space-x-4 mb-14">
          <div className="text-[17px] font-semibold text-black  ">
            {" "}
            Connect to Slack
          </div>
          <X onClick={() => setOpen(false)} className="text-gray-400" />
        </div>

        <div>
          <div className="flex justify-center mb-2">
            <img
              src="/icons/slack.png"
              className="text-[#4F46E5]  w-[40px] h-[40px]"
            />
          </div>
          <div className="lg:text-[14px] text-[13px] text-center">
            Click the button below to connect your Slack workspace to
            Twilanswer.
          </div>
        </div>

        <div className="flex items-center justify-center mt-4">
          <button
            type="button"
            className="p-0 border-0 bg-transparent cursor-pointer focus:outline-none focus-visible:ring-2 focus-visible:ring-[#611f69] focus-visible:ring-offset-2 focus-visible:rounded-md"
            onClick={() => {
              window.open(
                "https://slack.com/oauth/v2/authorize?scope=incoming-webhook&client_id=8216119482166.8222742235810&redirect_uri=" +
                  redirectUri +
                  "&state=channel_id:" +
                  channel_id,
                "_blank"
              );
            }}
          >
            <img
              src="/btn-add-to-slack-2x.png"
              alt="Add to Slack"
              className="block w-[147px] h-[44px] max-w-full shrink-0"
              width={147}
              height={44}
              draggable={false}
            />
          </button>
        </div>

        <div className="flex items-center justify-start space-x-3 mt-14">
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "white",
              color: "#374151",
              py: "6px",
              px: "30px",
              borderRadius: "7px",
              border: "1.5px solid #D1D5DB",
              fontSize: { lg: "14px", xs: "13px" },
              width: "fit",
            }}
            onClick={() => {
              setOpen(false);
            }}
          >
            Back
          </Button>
        </div>
      </div>
    </Dialog>
  );
};

export default AddToSlackModal;
